import React from 'react'
import Layout from '../Layout'
import DashboardLayout from '../DashboardLayout'
import UserMessage from '../../../utils/CommonFunctionality/Message'
import { useTranslation } from 'react-i18next'

const Message = (props) => {
    const { t } = useTranslation()
    return (
        <Layout props={props}>
            <DashboardLayout title={t('messages')}>
                <div className="mt-4">
                    <UserMessage data={props} />
                </div>
            </DashboardLayout>
        </Layout>
    )
}

export default Message
